module.exports = __webpack_public_path__ + "static/img/10.539a2c7c.png";